import PropTypes from 'prop-types'
import {
  StyledAddress,
  StyledPersonalInfo,
  StyledPersonalInfoDivider,
  StyledPersonalInfoStack,
  StyledPersonalInfoTypography,
  StyledPersonalInfoTypographyAlt
} from './Styles'
import {Divider} from '@mui/material'

const renderPersonalInfo = ({address, city, state}, numberOfPeople, squareFeet, zip, age) => {
  return (
    <StyledPersonalInfo>
      <StyledAddress>
        {address}, {city}, {state} {zip}
      </StyledAddress>
      <StyledPersonalInfoDivider />

      <StyledPersonalInfoStack direction="row" spacing={1}>
        <StyledPersonalInfoTypography>
          No of people: <strong>{numberOfPeople}</strong>
        </StyledPersonalInfoTypography>
        <Divider orientation="vertical" flexItem />
        <StyledPersonalInfoTypography>
          Oldest Age: <strong>{age}</strong>
        </StyledPersonalInfoTypography>
        <Divider orientation="vertical" flexItem />
        <StyledPersonalInfoTypographyAlt>
          Sq.ft: <strong>{squareFeet === '0 or blank' ? 'Unknown' : squareFeet}</strong>
        </StyledPersonalInfoTypographyAlt>
      </StyledPersonalInfoStack>
    </StyledPersonalInfo>
  )
}

renderPersonalInfo.propTypes = {
  address: PropTypes.shape({
    address: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired
  }).isRequired,
  numberOfPeople: PropTypes.number.isRequired,
  squareFeet: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  zip: PropTypes.string.isRequired,
  age: PropTypes.number.isRequired
}

export {renderPersonalInfo}

/**
 * List of functions and their purpose:
 *
 * - renderPersonalInfo: Renders detailed personal and household information, including address, age, number of people, and square footage.
 */
